import { createSharedStoreHook } from 'shared-store-hook'

export const useContext = createSharedStoreHook({
    initialState: {
        doodle: ()=>{},
        formatTime: ()=>{},
        formatDate: (date)=>{return date.toLocaleString()}
    }
})